import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail_step-end",
  "use": "icon-detail_step-end-usage",
  "viewBox": "0 0 155 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 155 32\" id=\"icon-detail_step-end\"><path d=\"M3.813 0h149.116a2 2 0 012 1.962l.268 14.046v.076l-.23 11.993a4 4 0 01-4 3.923H3.825a2 2 0 01-1.642-3.141l8.112-11.675a2 2 0 00.003-2.278l-8.13-11.77A2 2 0 013.812 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol